// @flow

import * as React from "react";

import Icons from "../../constants/Icons";

type PropsType = {
    width?: string,
    height?: string,
    name: string,
    style?: {},
    className?: string,
    color?: string,
};

const Icon = (props: PropsType): React.Node => {
    const cssBaseClass = "icon";
    const classList = [cssBaseClass];

    let MatchedIcon = Icons[props.name];

    React.useEffect(() => {
        if (!MatchedIcon) {
            console.error(`Could not find matching svg for '${props.name}'`);
        }
    }, [props.name, MatchedIcon]);

    if (props.className) {
        classList.push(`icon-${props.name}`);
    }

    if (props.className) {
        classList.push(props.className);
    }

    if (MatchedIcon) {
        return <MatchedIcon {...props} className={classList.join(" ")} />;
    } else {
        return null;
    }
};

Icon.defaultProps = {
    width: "100%",
    height: "1em",
};

export default Icon;
